import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import AppIcon from '../../../../components/AppIcon';
import Tooltip from '../../../../components/Tooltip';
import { truncateTicker } from '../../../../utils/helpers';

const AppInfo = ({
  app,
  size,
  direction = 'horizontal',
  showTicker = false,
  enableTooltip = false,
  className,
  appNameClassName,
  decorateTicker,
}) => (
  <Tooltip content={enableTooltip ? app.name : null}>
    <div className={cx('app-info', className, direction)}>
      <AppIcon url={app.icon_url} size={size} alt={app.name} withBorder />
      <div className="text-block">
        <p className={cx('app-name', appNameClassName)}>{app.name}</p>
        {showTicker && (
          <p className="app-ticker text-truncate">
            {decorateTicker ? decorateTicker(app.ticker) : truncateTicker(app.ticker)}
          </p>
        )}
      </div>
    </div>
  </Tooltip>
);

AppInfo.propTypes = {
  app: T.shape({
    icon_url: T.string,
    name: T.string,
    ticker: T.string,
  }).isRequired,
  size: T.number,
  direction: T.oneOf(['horizontal', 'vertical']),
  showTicker: T.bool,
  enableTooltip: T.bool,
  className: T.string,
  appNameClassName: T.string,
  decorateTicker: T.func,
};

export default AppInfo;
